import React from "react"
import clsx from "clsx"
import ErrorHelper from "../../Errors/ErrorHelper"
class OwnerDetailBuilderGeneral extends React.Component {

  constructor(props) {
    super(props);
    this.addressInputRef = React.createRef();
    this.autocomplete = null;
  };

  initializeAutocomplete() {
    if (window.google && window.google.maps && window.google.maps.places && this.addressInputRef.current) {
      this.autocomplete = new window.google.maps.places.Autocomplete(this.addressInputRef.current, {
        types: ['address']
      });
      
      this.autocomplete.addListener('place_changed', () => {
        const place = this.autocomplete.getPlace();
        if (place.formatted_address) {
          this.props.onChange('address', { target: { value: place.formatted_address } });
        }
      });
    } else {
      // Retry after a short delay if Google Maps API isn't loaded yet
      setTimeout(() => this.initializeAutocomplete(), 100);
    }
  }

  componentDidMount() {
    this.initializeAutocomplete();
  }

  componentWillUnmount() {
    if (this.autocomplete) {
      window.google.maps.event.clearInstanceListeners(this.autocomplete);
    }
  }

  render() {
    var tabClasses = clsx({
      'active': this.props.active_tab == 'general',
      'tab-pane': true
    });

    return (
      <div className={tabClasses} id="general">
        {ErrorHelper.renderErrors(this.props.errors, ['first_name', 'last_name', 'email', 'phone', 'address','percentage_of_ownership'])}
        {this.renderForm()}
      </div>
    );
  }

  renderForm() {
    return (
      <div>
        <input type="hidden" name={this.inputName('id')} value={this.props.id || ''} />
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{`${I18n.t('first_name')}*`}</label>
              <br />
              <input type="text" name={this.inputName('first_name')} value={this.props.first_name || ''} onChange={this.props.onChange.bind(this, 'first_name')} className={`form-control ${ErrorHelper.renderFieldClasses('first_name', this.props.errors)}`} data-model="OwnerDetail" data-column="first_name" />
              {ErrorHelper.renderFieldErrors('first_name', this.props.errors)}   
            </div>
          </div>

          <div className="col-md-6">
            <div className="form-group">
              <label>{`${I18n.t('last_name')}*`}</label>
              <br />
              <input type="text" name={this.inputName('last_name')} value={this.props.last_name || ''} onChange={this.props.onChange.bind(this, 'last_name')} className={`form-control ${ErrorHelper.renderFieldClasses('last_name', this.props.errors)}`} data-model="OwnerDetail" data-column="last_name" />
              {ErrorHelper.renderFieldErrors('last_name', this.props.errors)}   
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{`${I18n.t('address')}*`}</label>
              <br />
              <input 
                type="text" 
                name={this.inputName('address')} 
                value={this.props.address || ''} 
                onChange={this.props.onChange.bind(this, 'address')} 
                className={`form-control ${ErrorHelper.renderFieldClasses('address', this.props.errors)}`} 
                data-model="OwnerDetail" 
                data-column="address"
                ref={this.addressInputRef}
              />
              {ErrorHelper.renderFieldErrors('address', this.props.errors)}   
            </div>
          </div>

          <div className="col-md-6">
            <div className="form-group">
              <label>{`${I18n.t('phone')}*`}</label>
              <br />
              <input type="text" name={this.inputName('phone')} value={this.props.phone || ''} onChange={this.props.onChange.bind(this, 'phone')} className={`form-control ${ErrorHelper.renderFieldClasses('phone', this.props.errors)}`} data-model="OwnerDetail" data-column="phone" />
              {ErrorHelper.renderFieldErrors('phone', this.props.errors)}   
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{`${I18n.t('email')}*`}</label>
              <br />
              <input type="text" name={this.inputName('email')} value={this.props.email || ''} onChange={this.props.onChange.bind(this, 'email')} className={`form-control ${ErrorHelper.renderFieldClasses('email', this.props.errors)}`} data-model="OwnerDetail" data-column="email" />
              {ErrorHelper.renderFieldErrors('email', this.props.errors)}   
            </div>
          </div>
        </div>
      </div>
    );
  }

  inputName(name) {
    return `owner_detail[${name}]`;
  }

};

export default OwnerDetailBuilderGeneral